//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';

export const getWebhookEventTitle = (event: string, eventTitle: string): string => {
	const $format = get(format);
	return $format(`option_${eventTitle.replace('.', '_')}`, {
		default: getWebhookEventTitleDefault(event, eventTitle),
	});
};

const getWebhookEventTitleDefault = (event: string, eventTitle: string): string => {
	const eventTitleDefaults = {
		'camera.motion': 'Motion detected',
		'camera.motion_end': 'Motion stopped',
		'camerazone.motion': 'Motion detected in zone',
		'camerazone.motion_end': 'Motion stopped in zone',
		'lnm.rx_status': 'LNM status received',
		'lnm.rx_event': 'LNM event received',
	};
	return eventTitleDefaults[event] || eventTitle.replace(/(\.|_)/g, ' ');
};
